import { Dropdown } from 'components/dropdown/Dropdown';
import {
    getIssuePriority,
    IssuePriorities,
    IssuePriority,
} from 'pages/Desk/issues/shared';
import { Text, useIssueSidebarDropdownTriggerOptions } from 'pages/Desk/issues/styled';
import { CSSProperties, useMemo } from 'react';
import { SecondaryText } from 'styles/theme_styles/text';

const format = (priority: IssuePriority) =>
    `${priority.priorityValue} - ${priority.label} Priority`;

export type IssuePriorityDropdownProps = Readonly<{
    id?: string;
    value: number | undefined;
    className?: string;
    style?: CSSProperties;
    onChange: (newValue: number) => void;
    isDisabled?: boolean;
}>;

export function IssuePriorityDropdown({
    id,
    value,
    style,
    className,
    onChange,
    isDisabled = false,
}: IssuePriorityDropdownProps) {
    const priority = useMemo(
        () => (value !== undefined ? getIssuePriority(value) : undefined),
        [value],
    );

    return (
        <Dropdown<IssuePriority>
            id={id}
            trigger={{
                ...useIssueSidebarDropdownTriggerOptions(style),
                className,
            }}
            dataKey={({ priorityValue }) => priorityValue}
            renderLabel={(info) => (
                <SecondaryText>
                    {info.value ? format(info.value) : 'Choose the Priority'}
                </SecondaryText>
            )}
            renderItem={({ item }) => <Text>{format(item)}</Text>}
            data={IssuePriorities}
            value={priority}
            onChange={(newValue) => onChange(newValue.priorityValue)}
            isDisabled={isDisabled}
        />
    );
}
